import { ButtonUnstyled, ContainerAtom, HeadingH2Atom, IconAtom } from "../../atoms";
import { ButtonMolecule } from "../button";
import styles from "./styles.module.scss";

interface Props {
  title: string;
  text?: any;
  cancelButton: {
    text: string;
    onClick: () => void;
    disabled?: boolean;
  };
  okeButton?: {
    text: string;
    onClick: () => void;
    disabled?: boolean;
  };
  extraInfo?: any;
}

export function PopupMolecule(props: Readonly<Props>) {
  return (
    <div id="popup" className={styles.popup}>
      <div className={styles.popup_inner}>
        <div className={styles.blue_inner}>
          <div className={styles.text}>
            <ContainerAtom type="between" direction="row">
              <HeadingH2Atom>{props.title}</HeadingH2Atom>
              <div className={styles.right}>
                <ButtonUnstyled onClick={props.cancelButton.onClick} id={"sluit"}>
                  <IconAtom icon={"icon-close-hover"} size={"small"} alt={"sluit"} />
                </ButtonUnstyled>
              </div>
            </ContainerAtom>
            {props.text && <p>{props.text}</p>}
            {props.extraInfo && <div>{props.extraInfo}</div>}
          </div>

          <ContainerAtom type="grid">
            {props.cancelButton && (
              <div className={styles.right}>
                <ButtonMolecule
                  text={props.cancelButton.text ?? "Annuleren"}
                  id={"annuleren_button"}
                  title={"Annuleren"}
                  disabled={props.cancelButton.disabled}
                  onClick={props.cancelButton.onClick}
                  type={"default"}
                />
              </div>
            )}
            {props.okeButton && (
              <div className={styles.right}>
                <ButtonMolecule
                  text={props.okeButton.text ?? "Oke"}
                  id={"oke_button"}
                  title={"Oke"}
                  disabled={props.okeButton.disabled}
                  onClick={props.okeButton.onClick}
                  type={"primary"}
                />
              </div>
            )}
          </ContainerAtom>
        </div>
      </div>
    </div>
  );
}
